export const FILTERS = 'filters';
export const CATEGORIES = 'categories';
export const MARKETS = 'markets';
export const TAGS = 'tags';
export const NUM_FILTERS = 3;
